import { from } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { gqlQuery } from "libs/awsLib";
import { 
  queryNoticedReports,
  queryNoticedArticles, 
  mutationNoticedReport,
  mutationDeleteNoticedReport,

  queryGetItemsIDNoticed,
  queryUpdateItemsNoticed,
  queryGetReportData,
} from "gql/index";
import {
  FETCH_NOTICED_ARTICLES,
  noticedArticlesFulfilled,
  fetchNoticedArticlesError,

  CREATE_REPORT,
  CREATE_REPORT_SUCCESS,
  createReportSuccess,
  createReportError,
  
  FETCH_REPORTS,
  fetchReportsSuccess,
  fetchReportsError,
  
  DELETE_REPORT,
  deleteReportSuccess,
  deleteReportError,

  GET_ITEMS_ID_NOTICED,
  getItemsIDNoticedSuccess,
  getItemsIDNoticedError,

  UPDATE_ITEMS_NOTICED,
  updateItemsNoticedSuccess,
  updateItemsNoticedError,

  GET_REPORT_DATA,
  getReportDataSuccess,
  getReportDataError,

} from "redux/actions/noticedArticles";


/* EPICS */
export const fetchNoticedArticlesEpic = action$ => action$.pipe(
  ofType(FETCH_NOTICED_ARTICLES),
  mergeMap(({ payload }) => {
    return from(
      gqlQuery(queryNoticedArticles, { ...payload })
        .then(({ noticedArticles }) => {
          const { paging } = noticedArticles;
          const noticedArticlesTotal = paging.total;
          const noticedArticlesFrom = paging.offset + paging.limit;

          return noticedArticlesFulfilled({
            noticedArticlesFrom,
            noticedArticlesTotal,
            noticedArticles: noticedArticles.noticedArticles,
          });
        })
        .catch(fetchNoticedArticlesError)
    );
  })
);

export const createReportEpic = action$ => action$.pipe(
  ofType(CREATE_REPORT),
  mergeMap(({ payload }) => 
    from(
      gqlQuery(mutationNoticedReport, payload)
        .then(() => createReportSuccess({
          from: 0,
          size: 10,
        }))
        .catch(createReportError)
    )
  )
);

export const fetchReportsEpic = action$ => action$.pipe(
  ofType(
    FETCH_REPORTS,
    CREATE_REPORT_SUCCESS
  ),
  mergeMap(({ payload }) => 
    from(
      gqlQuery(queryNoticedReports, payload)
        .then(response => {
          response.noticedReports.sort((a, b) => {
            if (a.createdAt > b.createdAt) return -1;
            if (a.createdAt < b.createdAt) return 1;
            return 0;
          });
          return fetchReportsSuccess(response.noticedReports);
        })
        .catch(fetchReportsError)
    )
  )
);

export const deleteReportEpic = action$ => action$.pipe(
  ofType(DELETE_REPORT),
  mergeMap(({ payload }) => 
    from(
      gqlQuery(mutationDeleteNoticedReport, { id: payload })
        .then(deleteReportSuccess)
        .catch(deleteReportError)
    )
  )
);


export const getItemsIDNoticedEpic = action$ => action$.pipe(
  ofType(GET_ITEMS_ID_NOTICED),
  mergeMap(({ payload }) => 
    from(
      gqlQuery(queryGetItemsIDNoticed, { ...payload })
        .then(getItemsIDNoticedSuccess)
        .catch(getItemsIDNoticedError)
    )
  )
);

export const updateItemsNoticedEpic = action$ => action$.pipe(
  ofType(UPDATE_ITEMS_NOTICED),
  mergeMap(({ payload }) => 
    from(
      gqlQuery(queryUpdateItemsNoticed, { ...payload})
        .then(updateItemsNoticedSuccess)
        .catch(updateItemsNoticedError)
    )
  )
);

const REPORT_DATA_PAGE_SIZE = 1000;

export const getReportDataEpic = action$ => action$.pipe(
  ofType(GET_REPORT_DATA),
  mergeMap(({ payload }) => {
    const fetchAll = async () => {
      const { from, to, profile } = payload;
      let offset = 0;
      let accumulated = [];
      while (true) {
        const response = await gqlQuery(queryGetReportData, { from, to, profile, offset });
        const articles = response?.getReportData?.articles ?? [];
        accumulated = accumulated.concat(articles);
        if (articles.length < REPORT_DATA_PAGE_SIZE) break;
        offset += REPORT_DATA_PAGE_SIZE;
      }
      return getReportDataSuccess({ getReportData: { articles: accumulated } });
    };
    return from(fetchAll().catch(getReportDataError));
  })
);
